var map = {
	"./2023/autumn/poster/today_best_team.png": "7d7d",
	"./2023/summer/poster/today_best_team.png": "afbe",
	"./2024/autumn/poster/today_best_team.png": "fdde",
	"./2024/summer/poster/today_best_team.png": "cff9",
	"./2024/winter/poster/today_best_team.png": "9920",
	"./2025/spring/poster/today_best_team.png": "7c02",
	"./2025/summer/poster/today_best_team.png": "c7aa",
	"./2025/winter/poster/today_best_team.png": "7062"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a1b9";